module.exports = __webpack_public_path__ + "static/media/instagram.7b362a8e.svg";